// extracted by mini-css-extract-plugin
module.exports = {"form":"Signup_form__2eD86","note":"Signup_note__3VTEl","termsAndConditions":"Signup_termsAndConditions__1DRLc","login":"Signup_login__3NOkm","listView":"Signup_listView__1y3wg"};